module.exports = __webpack_public_path__ + "static/media/05660036-GOT0wSgs.34a1273c.JPG";